<template>
    <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

        <h1 class="h6 mb-0 text-gray-600">Versão {{ sys_verssion }}</h1>

        <div class="topbar-divider d-none d-sm-block"></div>

        <h1 class="h6 mb-0 text-gray-600" v-if="usuario.type == 3">Super administrador</h1>
        <h1 class="h6 mb-0 text-gray-600" v-if="usuario.type == 2">Administrador</h1>
        <h1 class="h6 mb-0 text-gray-600" v-if="usuario.type == 1">Usuário</h1>

        <!-- Sidebar Toggle (Topbar) -->
        <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
            <i class="fa fa-bars"></i>
        </button>

        <!-- Topbar Navbar -->
        <ul class="navbar-nav ml-auto">

            <li class="nav-item no-arrow">
                <span class="nav-link" id="userDropdown">
                    <span class="mr-2 d-none d-lg-inline small">
                        <a href="http://suporte.dad.eng.br" target="_blank">Suporte</a>
                    </span>
                </span>
            </li>

            <li class="nav-item no-arrow">
                <span class="nav-link" id="userDropdown">
                    <span class="mr-2 d-none d-lg-inline small">
                        <a href="#" data-toggle="modal" data-target="#modal-logof">Sair</a>
                    </span>
                </span>
            </li>

            <div class="topbar-divider d-none d-sm-block"></div>

            <!-- Nav Item - User Information -->
            <li class="nav-item no-arrow">
                <span class="nav-link" id="userDropdown">
                    <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{ usuario.name }}</span>
                    <img class="img-profile rounded-circle" :src="(usuario.img) ? usuario.img : default_img" />
                </span>
            </li>
        </ul>
    </nav>
    <!-- End of Topbar -->
</template>

<script>
    export default {
        name: 'template-sidebar',

        computed: {
            sys_verssion(){ 
                return "2.1.0";
            },

            usuario(){ 
                return this.$store.state.user;
            },

            default_img(){ 
                return this.$store.state.config.logotipo;
            }
        },
    };
</script>

<style>
    .navbar-card {
        height: 60px
    }

    .nav-link {
        cursor: pointer;
    }
</style>
